import "./HeroPageComponent.scss";

import React from "react";

import {
  Grid2,
  Typography
} from "@mui/material";
import Button from "@mui/material/Button";

import {
  ContentHubDamAsset,
  PageHeader
} from "../../models/app-data-model";

export type HeroPageComponentProps = {
  hero: PageHeader;
  damAsset?: ContentHubDamAsset;
};


const HeroPageComponent: React.FC<HeroPageComponentProps> = ({ hero, damAsset }: HeroPageComponentProps) => {
  const prim_action_url = hero.primary_action?.reference[0]?.url;
  const sec_action_url = hero.secondary_button?.reference[0]?.url;

  return (
    <Grid2 container maxWidth="xl" className='hero'>
      <Grid2 size="grow" className="content">
        <h1>
          {hero.headline}
        </h1>
        {hero.hero_copy && <Typography variant="body1">
          {hero.hero_copy}
        </Typography>}
        {prim_action_url && hero.primary_action.label && <Button variant='contained' color='primary' size='large' href={prim_action_url}>
          {hero.primary_action.label}
        </Button>}
        {sec_action_url && hero.secondary_button.label && <Button variant='outlined' size='large' color='secondary' title={hero.secondary_button.label} href={sec_action_url}>
          {hero.secondary_button.label}
        </Button>}
      </Grid2>
      {damAsset?.url && <Grid2 size={{ md: 6}} className="hero-image" style={{backgroundImage:`url(${damAsset?.url})` }}>
        
      </Grid2>}
    </Grid2>
  );
};
export default HeroPageComponent;
